import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Trash2 } from "lucide-react";
import { Slider } from "../../components/ui/slider";
import { api, assetUrl, errorMessage } from "../../lib/api";
import { useLang } from "../../lib/i18n";

const btn = "btn-press inline-flex min-h-[40px] items-center gap-2 rounded-xl px-3 text-sm font-semibold disabled:opacity-60";

export const BackgroundPicker = ({ d, onDesign, onOverlay }) => {
  const { t } = useLang();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const run = async (req) => {
    setBusy(true);
    try { const { data } = await req(); onDesign(data.design); toast.success(t("saved")); }
    catch (e) { toast.error(errorMessage(e)); }
    finally { setBusy(false); if (input.current) input.current.value = ""; }
  };
  const onFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    run(() => api.post("/admin/settings/profile-design/background", form));
  };

  return (
    <div className="space-y-2" data-testid="profile-background">
      <div className="flex flex-wrap items-center gap-2">
        {d.bg_image_url && <img src={assetUrl(d.bg_image_url)} alt="" className="h-10 w-16 rounded-lg object-cover ring-1 ring-slate-200" data-testid="profile-background-thumb" />}
        <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={onFile} data-testid="profile-background-input" />
        <button type="button" disabled={busy} onClick={() => input.current?.click()} data-testid="profile-background-upload" className={`${btn} bg-slate-900 text-white`}>
          <ImagePlus className="h-4 w-4" /> {busy ? t("Uploading…") : d.bg_image_url ? t("Change image") : t("Upload image")}
        </button>
        {d.bg_image_url && (
          <button type="button" disabled={busy} onClick={() => run(() => api.delete("/admin/settings/profile-design/background"))} data-testid="profile-background-remove"
            className={`${btn} border border-slate-300 text-slate-700 hover:border-red-400 hover:text-red-600`}>
            <Trash2 className="h-4 w-4" /> {t("Remove")}
          </button>
        )}
      </div>
      {d.bg_image_url && (
        <div className="flex max-w-sm items-center gap-3">
          <span className="shrink-0 text-xs font-semibold text-slate-600">{t("Darken")}</span>
          <Slider value={[d.bg_overlay]} min={0} max={90} step={5} onValueChange={([v]) => onOverlay(v)} data-testid="profile-background-overlay" />
          <span className="w-10 shrink-0 text-end font-mono text-xs text-slate-500">{d.bg_overlay}%</span>
        </div>
      )}
      <p className="text-xs text-slate-400">{t("A photo or pattern employees can pick for the top of their card, next to the brand colours. Wide images (at least 1200px) look best.")}</p>
    </div>
  );
};
